/**
 * Heading conversion between the scene's Three.js Y-rotation and a true compass
 * heading (degrees, 0 = north, clockwise).
 *
 * The persisted `areas.placement_heading` is a TRUE compass bearing (0 = north,
 * clockwise) — what a user reads off a map. `ZoneGeometry.placementHeadingDeg`
 * is the in-memory scene Y-rotation the engine applies directly as the aircraft's
 * Three.js `rotation.y`. Convert at the DB boundary (loadZoneGeometry on read,
 * ZonePlacementPanel on save).
 *
 * Under the scene convention (+X = east, +Y = up, +Z = south) with the model nose
 * facing +Z at rotation 0, a plane at scene rotation `θ` points at compass
 * `(180 − θ)`. e.g. compass 350° is stored as 350 and applied as scene rotation
 * 190°.
 *
 * The mapping is its own inverse, so a single function converts both ways.
 */
const flip = (deg: number) => (((180 - deg) % 360) + 360) % 360

/** Scene Y-rotation (deg) → true compass heading (deg, 0 = north). */
export const sceneRotationToCompass = flip

/** True compass heading (deg, 0 = north) → scene Y-rotation (deg). */
export const compassToSceneRotation = flip
